module.exports = __webpack_public_path__ + "AvenirNext-Medium-2ba58e05dc9ed4e19fcfa24ba8db073e.ttf";